import { Button } from '@mui/material';
import React from 'react';
import { Icons } from '../../icons/Icons';
import I18n from '../../i18n/I18n';

export default ({ onClick }: { onClick: () => void }) => {
    return (
        <Button variant="outlined" startIcon={<Icons.FileUpload />} sx={{ float: 'center' }} onClick={onClick}>
            <I18n token="common.upload" />
        </Button>
    );
};
